import { Card, CardBody, Col, Row } from "react-bootstrap"

const DashCountCard = ({schema, cardTitle, count, cardLink}) => {

    const borderActive = `border-${schema}`;
    const borderInactive = 'border-secondary';
    const textActive = `text-${schema}`;
    const textInactive = 'text-muted';

    return (
        <Card style={{borderRadius: 15}} className="shadow-lg">
            <CardBody>
                <Row className="align-items-center">
                    <Col xs="5">
                        <div className={count > 0? borderActive : borderInactive} style={{fontSize: 30, border: `10px solid`, borderRadius: 70, padding: 10, textAlign: 'center', display: 'flex', flexDirection: 'column'}}>
                            <span className={count > 0? textActive: textInactive}>{count}</span>
                            <small style={{fontSize: 14}}>Neue</small>
                        </div>
                    </Col>
                    <Col>
                        <b>{cardTitle}</b>
                    </Col>
                </Row>
                <Row>
                    <Col className="text-end">
                        <a href={cardLink? cardLink: "#"} className="link-energo">alle ansehen</a>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}
export default DashCountCard;